// extracted by mini-css-extract-plugin
module.exports = {"comp":"WhatInBoxA_comp__6p1oF"};